var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1c6f97",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50.58 70.89a12.79 12.79 0 0 1 -10.11-9.62 1.93 1.93 0 0 0 -1.89-1.51h-1.89a1.94 1.94 0 0 0 -1.88 2.24 18.2 18.2 0 0 0 17.83 14.74h.36a17.14 17.14 0 0 1 -2.42-5.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.24 37.12v-14.12a2.78 2.78 0 0 0 -2.83-2.83h-3.77a2.83 2.83 0 1 0 0 5.66h.94v11.29a11.32 11.32 0 0 1 -22.64 0v-11.32h.94a2.83 2.83 0 1 0 0-5.66h-3.77a2.78 2.78 0 0 0 -2.83 2.86v14.12a17 17 0 0 0 34 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.3 54.58a12.63 12.63 0 1 0 12.63 12.63 12.67 12.67 0 0 0 -12.63-12.63zm7.1 17.67a1.88 1.88 0 0 1 -1.89 1.81h-10.09a1.83 1.83 0 0 1 -1.89-1.81v-.25c0-1.69 1.85-2.6 3.78-3.38 1.3-.56 1.5-1 1.5-1.58a2.14 2.14 0 0 0 -.81-1.49 3.48 3.48 0 0 1 -1.18-2.76 3.67 3.67 0 1 1 7.33 0 3.7 3.7 0 0 1 -1.15 2.76 2.23 2.23 0 0 0 -.88 1.45c0 .55.16 1 1.5 1.58 1.93.78 3.74 1.69 3.78 3.38z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.dc18c239b479f25fc48d18366e3a4894.svg";
export { ForwardRef as ReactComponent };